(function (algolia) {
  'use strict';

  window.algolia = window.algolia || {};
  window.algolia.clickTracker = function () {};
  window.algolia.algolia_conversionTracker = function () {};
  window.algolia.userToken = '';

  if (!algolia.config.analytics_enabled) return;

  var ALGOLIA_INSIGHTS_SRC =
    'https://cdn.jsdelivr.net/npm/search-insights@1.3.1';

  !(function (e, a, t, n, s, i, c) {
    (e.AlgoliaAnalyticsObject = s),
      (e[s] =
        e[s] ||
        function () {
          (e[s].queue = e[s].queue || []).push(arguments);
        }),
      (i = a.createElement(t)),
      (c = a.getElementsByTagName(t)[0]),
      (i.async = 1),
      (i.src = n),
      c.parentNode.insertBefore(i, c);
  })(window, document, 'script', ALGOLIA_INSIGHTS_SRC, 'aa');

  aa('init', {
    appId: algolia.config.app_id,
    apiKey: algolia.config.search_api_key,
  });

  function getCookie(cname) {
    var name = cname + '=';
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return null;
  }

  function setCookie(cname, cvalue) {
    var d = new Date();
    d.setFullYear(d.getFullYear() + 2); // Expire in 2 years
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  var userToken =
    (window.bounteous &&
      window.bounteous.customer &&
      window.bounteous.customer.id) ||
    null;

  if (userToken) {
    userToken = userToken.toString().concat('_signed_in');
  } else {
    var cookie = getCookie('AlgoliaIDCookie');

    if (cookie) {
      userToken = cookie;
    } else {
      // Number.MAX_SAFE_INTEGER = 9007199254740991 (the constant doesn't exist in IE11)
      userToken = Math.floor(Math.random() * 9007199254740991).toString();
      setCookie('AlgoliaIDCookie', userToken);
    }
  }

  window.algolia.userToken = userToken;

  window.algolia.clickTracker = function (data) {
    try {
      var message = { userToken: userToken };

      for (var key in data) {
        message[key] = data[key];
      }
      window.aa('clickedObjectIDsAfterSearch', message);
    } catch (err) {
      // If the user isn't logged in they have no token and algolia throws an error.
      // According to algolia, it'll still track analytics just not personalization
    }
    var viewedItems =
      sessionStorage.getItem('algolia_analytics_clicked_objects') || '[]';
    var viewedItemsArray = JSON.parse(viewedItems);

    var onlyUniqueItems = viewedItemsArray.filter(function (i) {
      if (!i.objectIDs || !i.objectIDs[0]) {
        return false;
      }

      return i.objectIDs[0] !== data.objectIDs[0];
    });
    onlyUniqueItems.push(data);
    sessionStorage.setItem(
      'algolia_analytics_clicked_objects',
      JSON.stringify(onlyUniqueItems)
    );
  };

  window.algolia.conversionTracker = function () {
    var viewedItems = sessionStorage.getItem(
      'algolia_analytics_clicked_objects'
    );
    if (!!viewedItems) {
      var cartItems = window.bounteous.cart_items;
      var viewedItemsArray = JSON.parse(viewedItems);

      var matchItemsToCart = viewedItemsArray.reduce(function (
        matched,
        storedItem
      ) {
        for (var i = 0; i < cartItems.length; i++) {
          if (cartItems[i].id === parseInt(storedItem.objectIDs[0])) {
            return [].concat(matched, storedItem);
          }
        }
        return matched;
      },
      []);

      matchItemsToCart.forEach(function (data) {
        if (data.objectIDs.length && data.queryID) {
          try {
            window.aa('convertedObjectIDsAfterSearch', {
              eventName: 'convert_from_search',
              userToken: userToken,
              objectIDs: data.objectIDs,
              queryID: data.queryID,
              index: data.index,
            });
          } catch (err) {
            // Same as above call to window.aa
          }
        }
      });

      sessionStorage.removeItem('algolia_analytics_clicked_objects');
    }
  };

  window.algolia_conversionTracker = window.algolia.conversionTracker
    ? window.algolia.conversionTracker
    : window.algolia.algolia_conversionTracker;
})(window.algoliaShopify);
